import React, { useEffect, useCallback } from "react";
import { initViewer } from "./viewer.js";
import { setupModelSelection } from "./main.js";
import "./main.css";

function ViewerComponent({ setViewController, setUrn }) {
  const initializeViewer = useCallback(() => {
    const Autodesk = window.Autodesk;
    initViewer(document.getElementById("preview"), Autodesk).then((viewer) => {
      setViewController(viewer);
      setupModelSelection(viewer, setUrn);
    });
  }, [setViewController, setUrn]);

  useEffect(() => {
    initializeViewer();
  }, [initializeViewer]);

  return (
    <div className="tunnelModel">
      <div id="preview"></div>
      <div id="overlay"></div>
    </div>
  );
}

export default ViewerComponent;

